<template>
  <div class="main">
    <div class="logo"></div>
  <div class="content resetpwd">
    <div class="title font-size24 color-msg">找回密码</div>
    <div class="ipt-box font-size14">
      <mobile-input @btnEnable="btnEnable" @btnDisable="btnDisable" @hideImgCode="hideImgCode" :inputType="CONF.inputType.mobileOrEmail" :errData="errData"></mobile-input>
    </div>
    <div class="account-btn" @click="getAccount()" v-show="submitBtnState==CONF.submitBtnState.enable">下一步</div>
    <div class="account-btn disable" v-show="submitBtnState==CONF.submitBtnState.disable">下一步</div>
  </div>
  </div>
</template>
<style>
  .resetpwd .title{
    margin-bottom: 30px;
  }
</style>
<script>
  import {mtvConfig as CONF, mtvServers as server} from '../services/services'
  import MobileInput from '../components/mobileInput'
  import MobileCode from '../components/mobileCode'
  import ImgCode from '../components/imgCode'

  export default {
    components: {MobileInput, MobileCode, ImgCode},
    data () {
      return {
        step: 3,
        CONF: CONF,
// 用户填写
        mobile: '',
// 接口返回
        account: '',
        countryCodeIndex: 0,
        submitBtnState: CONF.submitBtnState.disable,
        inputType: CONF.inputType.mobile,
        errData: {},
        search: window.location.search
      }
    },
    created () {
    },
    methods: {
// 按钮可用
      btnEnable (mobile, countryCodeIndex) {
        this.mobile = mobile
        this.countryCodeIndex = countryCodeIndex
        this.submitBtnState = CONF.submitBtnState.enable
      },
// 按钮不可用
      btnDisable (mobile) {
        this.mobile = mobile
        this.submitBtnState = CONF.submitBtnState.disable
      },
      hideImgCode (countryCodeIndex) {
        this.countryCodeIndex = countryCodeIndex
      },
// 验证帐号格式
      getAccountType () {
        if ((this.countryCodeIndex === 0 && CONF.reg.chinaPhone.test(this.mobile)) || (this.countryCodeIndex !== 0 && CONF.reg.otherPhone.test(this.mobile))) {
          this.inputType = CONF.inputType.mobile
          return true
        } else {
          if (CONF.reg.email.test(this.mobile)) {
            this.inputType = CONF.inputType.mobileOrEmail
            return true
          } else {
            return false
          }
        }
      },
// 获取用户信息
      getAccount () {
        if (!this.getAccountType()) return
        let that = this
        let data = {}
        if (this.inputType === CONF.inputType.mobile) {
          data = {account: this.mobile, ncode: CONF.countryList[this.countryCodeIndex].code}
        } else {
          data = {account: this.mobile}
        }
        this.submitBtnState = CONF.submitBtnState.disable
        server.appServices(this, CONF.APIList.validateAccount, data).then(res => {
          if (res.status === CONF.errCode.success.code) {
            let nextRoute = CONF.urlList.ResetGetCode
            nextRoute.query = {}
            if (this.$route.query.callback) {
              nextRoute.query.callback = this.$route.query.callback
            }
            if (this.$route.query.connectid) {
              nextRoute.query.connectid = this.$route.query.connectid
            }
            nextRoute.params = {account: res.data, inputType: this.inputType}
            this.$router.push(nextRoute)
          } else {
            this.submitBtnState = CONF.submitBtnState.enable
            that.errData = {errMsgShow: true, errMsg: CONF.errCode['code' + res.status].msg}
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ResetGetAccount.vue?a24eeb76